import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { checkIfArticleLineisOrderable } from 'src/app/business/order/order-functions';
import { OrderedArticleLineViewModel } from 'src/app/business/order/view-models/ordered-article-line-view-model';
import { SingleOrderViewModel } from 'src/app/business/single-order/single-order-view-model';
import { TenantConfigService } from 'src/app/shared/services/tenant-config/tenant-config.service';

interface DefaultAnnotation {
  value: string;
  active: boolean;
}
@Component({
  selector: 'itl-single-order-summary',
  templateUrl: './single-order-summary.component.html',
  styleUrls: ['./single-order-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleOrderSummaryComponent implements OnInit {
  @Input()
  public order: SingleOrderViewModel;
  public defaultAnnotations: DefaultAnnotation[];
  public maxAnnotationLength;
  public orderedActiveArticleLines = [];
  public isLoading = true;

  public showResmedTenant: boolean;

  constructor(private tenantConfigService: TenantConfigService, private ref: ChangeDetectorRef) {}

  async ngOnInit() {
    this.showResmedTenant = await this.tenantConfigService.showResmedTenant();
    this.orderedActiveArticleLines = this.order.orderedArticleLines.filter(
      orderedArticleLine =>
        orderedArticleLine.active && checkIfArticleLineisOrderable(orderedArticleLine.article, this.order.deliveryDate)
    );
    const config: any = await this.tenantConfigService.getTenantConfig();
    const orderDefaultAnnotations = config.orderDefaultAnnotations || [];
    const configMaxAnnotationLength = await this.tenantConfigService.getOrderMaxAnnotationLength();
    if (configMaxAnnotationLength) {
      this.maxAnnotationLength = configMaxAnnotationLength;
    }
    this.defaultAnnotations = orderDefaultAnnotations.map(value => ({ value, active: false }));
    this.ref.markForCheck();
    this.isLoading = false;
  }

  public addAnnotation(annotation: DefaultAnnotation) {
    this.order.annotation = this.order.annotation || '';
    if (`${this.order.annotation} ${annotation.value}`.trim().length > this.maxAnnotationLength) {
      return;
    }
    this.order.annotation += ` ${annotation.value}`;
    this.order.annotation = this.order.annotation.trim();
    annotation.active = true;
  }
}
